import { render, staticRenderFns } from "./viewCollection.vue?vue&type=template&id=20c9c892&"
import script from "./viewCollection.vue?vue&type=script&lang=js&"
export * from "./viewCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports